'use client';

import Link from 'next/link';

const ExpertHelpCard = ({
    title = "Need Help?",
    description = "Connect with our experts for assistance.",
    buttonText = "Contact Expert",
    link = "/contact",
    bgClass = "bg-gradient-to-br from-violet-50 to-indigo-50/50",
    borderClass = "border-slate-100",
    roundedClass = "rounded-2xl",
    titleColorClass = "text-violet-900",
    descColorClass = "text-violet-900",
    btnTextColorClass = "text-violet-700 group-hover:text-violet-900",
    glowColor1 = "red",
    glowColor2 = "#7c3aed",
    animationSpeed = "3s",
}) => {
    const getInnerRoundedClass = (outer) => {
        if (outer === "rounded-xl") return "rounded-[10px]";
        if (outer === "rounded-2xl") return "rounded-[14px]";
        if (outer === "rounded-3xl") return "rounded-[22px]";
        if (outer === "rounded-4xl") return "rounded-[30px]";
        if (outer === "rounded-full") return "rounded-full";
        return "rounded-[14px]";
    };

    const innerRoundedClass = getInnerRoundedClass(roundedClass);

    return (
        <div
            className={`p-6 ${roundedClass} border shadow-sm transition-all duration-300 hover:shadow-md flex flex-col gap-4 ${bgClass} ${borderClass}`}
        >
            <div>
                <h3 className={`text-lg font-bold ${titleColorClass} mb-2`}>{title}</h3>
                <p className={`text-sm ${descColorClass} leading-relaxed`}>
                    {description}
                </p>
            </div>

            {/* Button with Running Border Outline */}
            <Link
                href={link}
                className={`relative block w-full p-[2px] ${roundedClass} overflow-hidden group shadow-sm transition-transform active:scale-[0.98]`}
            >
                {/* Running Border (Rotating Conic Gradient) */}
                <div
                    className="absolute inset-[-1000%] animate-border-rotate"
                    style={{
                        background: `conic-gradient(from 0deg, transparent 20%, ${glowColor1} 40%, ${glowColor2} 60%, ${glowColor1} 80%, yellow 100%)`,
                        animationDuration: animationSpeed,
                    }}
                />

                {/* Inner Button Content - Pure White Background */}
                <div
                    className={`relative w-full py-3 px-4 bg-white text-center ${innerRoundedClass} font-semibold text-sm transition-colors duration-300 flex items-center justify-center gap-2 z-10 ${btnTextColorClass} hover:bg-slate-50`}
                >
                    <span className="relative z-10">{buttonText}</span>

                    <svg
                        className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2.5}
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                </div>
            </Link>
        </div>
    );
};

export default ExpertHelpCard;